import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthGuard } from './auth.guard'; // Import the extended AuthGuard

@Injectable({
  providedIn: 'root',
})
export class AdminGuard implements CanActivate {
  constructor(private authGuard: AuthGuard, private router: Router) {}

  canActivate(): boolean {
    console.log('AdminGuard#canActivate called');
    if (this.authGuard.isAdmin()) {
      return true;
    } else {
      this.router.navigate(['/register']);
      return false;
    }
  }
}
